
export function BlogSection() {
  const blogPosts = [
    {
      id: 1,
      title: '5 Signs Your Pool Needs Replastering This Year',
      excerpt: 'Learn the telltale signs that indicate your pool surface is due for a refresh, from rough textures to visible staining.',
      category: 'Pool Tips',
      image: 'https://public.readdy.ai/ai/img_res/c5669c5e1e4041b3ef6c4e8e1ed5852e.jpg',
      date: 'Jan 15, 2025',
      readTime: '4 min read'
    },
    {
      id: 2,
      title: 'Paver Patterns That Transform Your Outdoor Space',
      excerpt: 'Discover the most popular paver patterns for driveways, patios, and walkways that add curb appeal and value to your home.',
      category: 'Design Ideas',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20paver%20patio%20design%20with%20herringbone%20pattern%2C%20outdoor%20living%20space%2C%20modern%20landscape%20design%2C%20warm%20earth%20tones%2C%20professional%20hardscape%20installation%2C%20simple%20clean%20background&width=600&height=400&seq=blog-paver-002&orientation=landscape',
      date: 'Jan 10, 2025',
      readTime: '5 min read'
    },
    {
      id: 3,
      title: 'Why Synthetic Grass is Perfect for Las Vegas Homes',
      excerpt: 'Save water and maintenance time with artificial turf. Here\'s why more Las Vegas homeowners are making the switch.',
      category: 'Landscaping',
      image: 'https://readdy.ai/api/search-image?query=Lush%20green%20synthetic%20artificial%20grass%20lawn%20in%20desert%20backyard%2C%20modern%20Las%20Vegas%20home%20exterior%2C%20water-saving%20landscape%2C%20clean%20neat%20appearance%2C%20bright%20daylight%2C%20simple%20background&width=600&height=400&seq=blog-grass-003&orientation=landscape',
      date: 'Jan 5, 2025',
      readTime: '3 min read'
    },
    {
      id: 4,
      title: 'Budget-Friendly Pool Deck Renovation Ideas',
      excerpt: 'Transform your pool area without breaking the bank. Smart renovation strategies that deliver maximum impact.',
      category: 'Budget Tips',
      image: 'https://readdy.ai/api/search-image?query=Modern%20pool%20deck%20renovation%20with%20travertine%20pavers%2C%20outdoor%20furniture%2C%20resort%20style%20backyard%2C%20Las%20Vegas%20home%2C%20warm%20sunset%20lighting%2C%20clean%20professional%20finish%2C%20simple%20background&width=600&height=400&seq=blog-deck-004&orientation=landscape',
      date: 'Dec 28, 2024',
      readTime: '6 min read'
    },
    {
      id: 5,
      title: 'How to Prepare Your Backyard for Summer Entertaining',
      excerpt: 'Get your outdoor space party-ready with these essential upgrades and maintenance tips from our experts.',
      category: 'Project Ideas',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20backyard%20entertainment%20area%20with%20outdoor%20kitchen%20and%20seating%2C%20string%20lights%2C%20modern%20patio%20design%2C%20summer%20party%20setup%2C%20warm%20evening%20ambiance%2C%20clean%20organized%20space%2C%20simple%20background&width=600&height=400&seq=blog-backyard-005&orientation=landscape',
      date: 'Dec 20, 2024',
      readTime: '5 min read'
    },
    {
      id: 6,
      title: 'Choosing the Right Materials for Desert Landscaping',
      excerpt: 'Navigate the best hardscape and softscape materials that thrive in Nevada\'s unique desert climate.',
      category: 'Construction Tips',
      image: 'https://readdy.ai/api/search-image?query=Desert%20landscaping%20with%20natural%20stone%20and%20drought%20tolerant%20plants%2C%20modern%20xeriscaping%20design%2C%20Las%20Vegas%20style%20yard%2C%20warm%20earth%20tones%2C%20professional%20landscape%20installation%2C%20simple%20clean%20background&width=600&height=400&seq=blog-desert-006&orientation=landscape',
      date: 'Dec 15, 2024',
      readTime: '4 min read'
    }
  ];

  const getCategoryColor = (category: string) => {
    const colors: { [key: string]: string } = {
      'Pool Tips': 'bg-blue-100 text-blue-700',
      'Design Ideas': 'bg-purple-100 text-purple-700',
      'Landscaping': 'bg-green-100 text-green-700',
      'Budget Tips': 'bg-amber-100 text-amber-700',
      'Project Ideas': 'bg-rose-100 text-rose-700',
      'Construction Tips': 'bg-teal-100 text-teal-700'
    };
    return colors[category] || 'bg-gray-100 text-gray-700';
  };

  return (
    <section id="blog" className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Blog</span>
          </div>
          <h2 className="text-5xl font-bold text-[#2C2C2C] mb-4">Construction Tips &<br />Project Ideas</h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Expert advice, inspiration, and practical guides to help you plan your next outdoor renovation project
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article 
              key={post.id}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img 
                  src={post.image}
                  alt={post.title}
                  title={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getCategoryColor(post.category)}`}>
                    {post.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {post.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {post.readTime}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#2C2C2C] mb-3 group-hover:text-[#FF6B35] transition-colors line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-2">
                  {post.excerpt}
                </p>
                <a 
                  href="#"
                  className="inline-flex items-center gap-2 text-[#FF6B35] font-semibold text-sm hover:gap-3 transition-all cursor-pointer"
                >
                  Read More
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button 
            className="bg-[#2C2C2C] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#1a1a1a] transition-all hover:scale-105 inline-flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            View All Articles
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
